<template>
  <div class="poll-maker">
    <template v-if="creating_new_poll">
      <div class="col-xs-12 tw-flex tw-items-center theme-font tw-mb-6 tw-text-base tw-mt-4">
        <i class="fa fa-chart-pie tw-pr-2"></i>
        <p class="tw-mb-0 tw-font-semibold tw-leading-tight">Start poll</p>
      </div>
      <div class="col-xs-12">
        <textarea v-model="poll_question" :placeholder="translations['forum.poll_question_placeholder']" class="form-control" col="8" maxlength="100"
                  name="question" type="text"></textarea>
      </div>
      <div class="col-xs-12">
        <template v-for="(answer, index) in poll_answers">
          <div :key="poll_answers.uid" class="tw-flex tw-mt-4 tw-items-center tw-mb-4">
            <input :key="'pollanswer' + index" v-model="answer.value" :name="'pollanswer' + index" class="tw-flex-1 tw-bg-white form-control"
                   placeholder="Answer" type="text">
            <div v-if="pollAnswersLength === index+1 || pollAnswersLength > 2"
                 class="tw-flex tw-items-center tw-justify-center tw-px-6">
              <i v-if="pollAnswersLength > 2" class="fa fa-trash warning-color hover-opacity"
                 @click="deleteAnswer(answer, index)"></i>
              <i v-if="pollAnswersLength === index+1" :class="{'tw-pl-6': pollAnswersLength > 2}"
                 class="fa fa-plus tw-text-gray-600 hover-opacity" @click="addPollAnswer"></i>
            </div>
          </div>
        </template>
      </div>
      <div class="col-xs-12 tw-flex tw-justify-between tw-mt-3 tw-items-end">
        <!-- poll settings -->
        <div class="">
          <div class="switch-wrapper">
            <div :class="{'active': poll_settings.retry === '1'}" class="switch" @click="switchPollSetting('retry')">
              <div class="thumb"></div>
            </div>
            <p>{{ translations['poll.allow_changing_answer'] }}</p>
          </div>
          <div class="switch-wrapper tw-mt-2">
            <div :class="{'active': poll_settings.poll_allow_guest_answers === '1'}" class="switch"
                 @click="switchPollSetting('poll_allow_guest_answers')">
              <div class="thumb"></div>
            </div>
            <p>{{ translations['poll.allow_guest_answers'] }}</p>
          </div>
          <div class="switch-wrapper tw-mt-2">
            <div :class="{'active': poll_settings.poll_public === '1'}" class="switch"
                 @click="switchPollSetting('poll_public')">
              <div class="thumb"></div>
            </div>
            <p>{{ translations['poll.show_who_voted_what'] }}</p>
          </div>
          <div class="switch-wrapper tw-mt-2">
            <div :class="{'active': poll_settings.poll_multiple_answers === '1'}" class="switch"
                 @click="switchPollSetting('poll_multiple_answers')">
              <div class="thumb"></div>
            </div>
            <p>{{ translations['poll.allow_multiple_answers'] }}</p>
          </div>
          <div v-if="poll_scheduled_date === ''" class="tw-flex tw-items-center tw-text-gray-400 hover-opacity tw-mt-3"
               @click="togglePollScheduler">
            <i class="far fa-calendar-alt tw-pr-2"></i>
            <p class="tw-mb-0">{{ translations['poll.add_end_date'] }}</p>
          </div>
          <div v-if="poll_scheduler_opened || poll_scheduled_date !== ''" :class="{'show': poll_scheduled_date}"
               class="poll-scheduled-date">
            <datetime ref="pollDatePicker"
                      v-model="poll_scheduled_date"
                      :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                      auto
                      type="datetime"
                      value-zone="Europe/Amsterdam"
                      v-on:close="togglePollScheduler"
                      v-on:input="setPollDate"></datetime>
          </div>
        </div>

        <!-- poll submit -->
        <div class="btn btn-success" @click="createPoll">
          {{ translations['forum.start_topic'] }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {Datetime} from 'vue-datetime';

export default {
	props: ['boardId'],

	components: {
		datetime: Datetime,
	},

	data() {
		return {
			storing_poll: false,
			poll_question: '',
			poll_answers: [
				{
					uid: 0,
					value: '',
				},
				{
					uid: 1,
					value: '',
				}
			],
			poll_settings: {
				retry: '0',
				poll_allow_guest_answers: '0',
				poll_public: '0',
				poll_multiple_answers: '0',
			},
			poll_scheduler_opened: false,
			poll_scheduled_date: '',
		};
	},

	computed: {
		...mapState([
			'creating_new_poll',
			'translations'
		]),

		pollAnswersLength() {
			return this.poll_answers.length;
		},
	},

	methods: {
		deleteAnswer(answer, index) {
			this.poll_answers.splice(index, 1);
		},

		addPollAnswer() {
			this.poll_answers.push({
				uid: Date.now() + ((Math.random() * 100000).toFixed()),
				value: '',
			});
		},

		createPoll() {
			//add settings!

			if (!this.storing_poll) {
				this.storing_poll = true;

				//prepare data for poll storing
				let poll_data = {
					title: this.poll_question,
					description: '',
					type: 'poll',
					settings: this.poll_settings,
				};

				if (this.poll_scheduled_date !== '') {
					poll_data.settings['end_date'] = moment(this.poll_scheduled_date).format('YYYY-MM-DD HH:mm:ss');
				}

				//prepare data for question storing
				let question_data = {
					is_active: true,
					question: this.poll_question,
					questionable_type: 'multiple_choice',
					type: 'multiple_choice',
					score: 1,
					answer: '',
					question_options: this.poll_answers,
				};

				//store the poll
				this.$store.dispatch('storePoll', poll_data).then((poll) => {
					//create a new question for the store (polls only have one question)
					this.$store.dispatch('storePollQuestion', {question: question_data, poll_id: poll.id}).then((question) => {
						//prepare the options for the question
						for (let i = 0; i < question_data.question_options.length; i++) {
							question_data.question_options[i].question_id = question.id;
						}

						question.question_options = question_data.question_options;

						//store all the options
						this.$store.dispatch('storePollQuestionOptions', question).then(() => {
							//create the topic
							this.createTopic(poll.id);
						});
					});
				});
			}
		},

		createTopic(poll_id) {
			//prepare data
			let data = {
				'title': this.poll_question,
				'content': this.poll_question,
				'channel_id': this.boardId,
				'post_type': 'poll',
				'upload_uuids': [],
				'quiz_id': poll_id,
			};

			this.$store.dispatch('createTopic', data);
		},

		switchPollSetting(setting) {
			if (this.poll_settings[setting] === '1') {
				this.poll_settings[setting] = '0';
			} else {
				this.poll_settings[setting] = '1';
			}
		},

		togglePollScheduler() {
			//toggle the scheduler
			this.poll_scheduler_opened = !this.poll_scheduler_opened;

			if (!this.poll_scheduled_date) {
				this.$nextTick(() => {
					//if its visible on the page
					if (this.$refs.pollDatePicker) {
						//activate it
						this.$refs.pollDatePicker.$el.firstElementChild.click();
					}
				});
			}
		},

		setPollDate(date) {
			if (date) {
				this.poll_scheduled_date = date;
			}
		},
	}
};
</script>

<style lang="scss">
.poll-maker {
  .hover-opacity {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .warning-color {
    color: #bb3825;
  }

  .switch-wrapper {
    @apply tw-flex tw-items-center;

    .switch {
      @apply tw-cursor-pointer tw-flex tw-bg-gray-300 tw-flex tw-items-center tw-relative;
      height: 28px;
      width: 65px;
      border-radius: 20px !important;
      padding-left: 4px;
      padding-right: 4px;
      transition: background 0.2s ease;

      .thumb {
        @apply tw-bg-white tw-absolute;
        border-radius: 100% !important;
        height: 22px;
        width: 22px;
        left: 3px;
        transition: left 0.2s ease;
      }

      &.active {
        @apply tw-bg-blue-500;

        .thumb {
          left: 39px;
        }
      }
    }

    p {
      @apply tw-pl-2 tw-text-gray-400 tw-mb-0;
    }
  }

  .poll-scheduled-date {
    position: relative;
    margin-top: 12px;

    &:before {
      display: none;
      position: absolute;
      content: "\f073";
      font-family: 'Font Awesome 5 Pro';
      color: #c7c7c7;
    }

    input {
      display: none;
      background: none;
      border: 0;
      padding: 0;
      padding-left: 20px;
      margin-top: 10px;
      color: #c7c7c7;
      font-size: 13px;

      &:hover {
        cursor: pointer;
      }
    }

    &:hover {
      cursor: pointer;
    }

    &.show {
      &:before {
        display: block;
      }

      input {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
